import { useQuery } from '@tanstack/react-query';
import inspectionApi from '../services/inspection.api';

export const inspectionKeys = {
  all: ['vehicle-inspections'],
  lists: () => [...inspectionKeys.all, 'list'],
  list: (filters) => [...inspectionKeys.lists(), filters],
  detail: (uuid) => [...inspectionKeys.all, 'detail', uuid],
  stats: () => [...inspectionKeys.all, 'stats'],
  monthFolders: (year) => [...inspectionKeys.all, 'month-folders', year],
};

const useVehicleInspections = (filters) =>
  useQuery({
    queryKey: inspectionKeys.list(filters),
    queryFn: () => inspectionApi.getList(filters),
    placeholderData: (previousData) => previousData,
  });

export default useVehicleInspections;
